import { ODataGetListFormModel } from '@evorait/pace-forms';
import { EquipmentModel } from '../../interfaces/equipment.interface';

export type AuthorsState = Readonly<{
    formsList: ODataGetListFormModel[];
    user: string;
    material: string;
    serialNo: string;
    orderNo: string;
    equipments: EquipmentModel[];
}>;

export const initialAuthorsState: AuthorsState = {
    formsList: [],
    user: '',
    material: '',
    serialNo: '',
    orderNo: '',
    equipments: [],
};
